import { IconType } from '@factorialco/f0-react'
import { FileFilled, Share } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type HeaderOptions = {
  infoIcon?: IconType
  info?: string
} | null

export const getHeaderOptions = (resultType: string): HeaderOptions => {
  switch (resultType) {
    case 'compensation':
      return {
        infoIcon: Share,
        info: i18n.t('compensations.PayrollRunCompensationsList.labelCompensationInfo'),
      }
    case 'payroll_result':
      return {
        infoIcon: FileFilled,
        info: i18n.t('compensations.PayrollRunCompensationsList.labelPayrollResultInfo'),
      }
    default:
      return null
  }
}
